<template>
    <b-navbar toggleable="md" class="top-nav" :type="navbarType">
        <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
        <div class="content-wrap">
          <b-collapse is-nav id="nav_collapse">
            <b-navbar-nav>
                <b-nav-item to="/home">Home</b-nav-item>
                <b-nav-item to="/makeaclaim">Make a claim</b-nav-item>
                <b-nav-item v-if="isStandalone" to="/myclaims/inprogress">Resume a claim</b-nav-item>
                <b-nav-item v-if="isTiga" to="/makeaclaim/resume">Resume a claim</b-nav-item>
                <b-nav-item to="/myclaims/list">Check status of a claim</b-nav-item>
                <b-nav-item to="/contact">Contact Us</b-nav-item>
            </b-navbar-nav>
            
            <user-auth />
            
          </b-collapse>
        </div>        
    </b-navbar>
</template>

<script>

import userAuth from '@/components/UserAuth.vue'

export default {
  name: 'topNav',
  props: {
    navbarType: {
      type: String,
      required: false,
      default: 'dark'
    }
  },
  components: {
    userAuth
  },
  computed: {
    isStandalone() {
      return process.env.VUE_APP_FORM_TYPE == 'standalone';
    },
    isTiga() {
      return process.env.VUE_APP_FORM_TYPE == 'tiga';
    }
  }
}
</script>



